import { render, staticRenderFns } from "./Tarjeta.vue?vue&type=template&id=32850a9f&scoped=true"
import script from "./Tarjeta.vue?vue&type=script&lang=ts"
export * from "./Tarjeta.vue?vue&type=script&lang=ts"
import style0 from "./Tarjeta.vue?vue&type=style&index=0&id=32850a9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32850a9f",
  null
  
)

export default component.exports